import { useState } from 'react';
import { reviews } from '@/mocks/reviews';

export default function TestimonialSection() {
  const [current, setCurrent] = useState(0);

  const prev = () => setCurrent((c) => (c === 0 ? reviews.length - 1 : c - 1));
  const next = () => setCurrent((c) => (c === reviews.length - 1 ? 0 : c + 1));

  const review = reviews[current];

  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="w-full lg:w-2/5">
            <div className="rounded-[2rem] overflow-hidden bg-accent-100 aspect-[4/5] relative">
              <img
                src="https://readdy.ai/api/search-image?query=Overhead%20view%20of%20organized%20desk%20workspace%20with%20color%20coded%20sticky%20notes%20and%20sleek%20laptop%20displaying%20spreadsheet%20interface%2C%20warm%20afternoon%20sunlight%20streaming%20through%20blinds%20creating%20striped%20shadow%20pattern%2C%20terracotta%20and%20cream%20color%20palette%2C%20productive%20creative%20workspace%20photography%2C%20satisfying%20orderly%20composition%20with%20personal%20touches%20like%20small%20succulent%20plant&width=800&height=1000&seq=mulebuy-testimonial-v2&orientation=portrait"
                alt="Mulebuy spreadsheet lifestyle"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="w-full lg:w-3/5">
            <span className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4 block">
              (User Reviews)
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 tracking-tight leading-tight mb-8">
              What Users Say<br />
              <span className="text-foreground-300">About the System</span>
            </h2>

            <div className="min-h-[180px]">
              <blockquote className="text-lg md:text-xl text-foreground-600 leading-relaxed">
                &ldquo;{review.content}&rdquo;
              </blockquote>
              <div className="mt-6">
                <p className="text-foreground-900 font-semibold text-base">
                  &mdash; {review.name}
                </p>
                <p className="text-foreground-400 text-sm">{review.role}</p>
              </div>
              <div className="flex gap-1 mt-3">
                {Array.from({ length: review.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-400 text-sm"></i>
                ))}
              </div>
            </div>

            <div className="flex items-center gap-3 mt-10">
              <button
                onClick={prev}
                className="w-11 h-11 rounded-full border border-foreground-200 flex items-center justify-center text-foreground-400 hover:text-foreground-700 hover:border-foreground-400 transition-all cursor-pointer"
              >
                <i className="ri-arrow-left-line text-lg"></i>
              </button>
              <button
                onClick={next}
                className="w-11 h-11 rounded-full bg-foreground-900 flex items-center justify-center text-background-50 hover:bg-foreground-800 transition-all cursor-pointer"
              >
                <i className="ri-arrow-right-line text-lg"></i>
              </button>
              <span className="text-sm text-foreground-400 ml-2">
                {current + 1} / {reviews.length}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}